(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["energyener-mineral-ring-edit"] && !Shopify.designMode) return;
  try {
    
  class EnergyenerRingEdit {
    constructor(root){
      this.root=root;
      this.variants=[...root.querySelectorAll('.ee-edit__variant-input')];
      this.cartConfig=JSON.parse(document.getElementById(`EnergyenerMoney-${root.dataset.sectionId}`).textContent);
      const galleryData=document.getElementById(`EnergyenerVariantMedia-${root.dataset.sectionId}`);
      this.variantMedia=galleryData?JSON.parse(galleryData.textContent):{};
      this.galleryIndex=0;
      this.group=root.dataset.colorGroup==='other'?'all':root.dataset.colorGroup;
      this.storyCopy={
      'EDIT-PINK-ENCOUNTER':{title:'Pink and cream\nin one ring.',body:'The pink-and-cream pairing is what makes Pink Encounter stand out. It adds color to a simple outfit, while the small crystal details give you something to notice up close.',view:2,proof:[['Two colors','Bright pink and warm cream sit opposite each other.'],['Crystal detail','Small crystals cover both clusters, with different shapes and textures on each side.'],['The setting','Silver-toned claws hold the two clusters. The close-up shows how they sit in the ring.']]},
      'EDIT-JWL-024':{title:'Purple from\nevery angle.',body:'Deep purple crystals sit beside lighter, translucent lavender edges. The current batch is purple throughout, with no yellow-gold patches. It’s a good choice if you want a richer color to wear with simple neutrals.',view:0,proof:[['Shades of purple','The color ranges from dark plum to pale lavender.'],['Crystal detail','The uneven crystal faces catch the light in different ways.'],['Natural differences','Each cluster has its own outline and arrangement of crystals.']]},
      'EDIT-JWL-032':{title:'A softer shade\nof blue.',body:'Glacier Bloom combines pale blue crystals with a fine white texture. Some areas let light through; others look frosted. The uneven cluster rises above the silver-toned setting, so there’s plenty of detail to see up close.',view:0,proof:[['Pale blue and white','The two colors sit together across the cluster.'],['Different textures','Larger, translucent crystals sit beside smaller white crystals.'],['The setting','The gallery shows the silver-toned setting and the parallel lines of the band.']]},
      'EDIT-JWL-011':{title:'A clear ring\nwith natural texture.',body:'Cloud Crown’s clear and white tones are easy to pair with different clothes. Look closer and you’ll see translucent crystals, uneven edges and the silver-toned setting around them.',view:0,proof:[['Clear and white tones','Light passes through parts of the pale crystal surface.'],['An uneven outline','The crystal edges give the ring its natural shape.'],['The setting','The silver-toned metal is visible around the mineral cluster.']]}
    };
      this.facts={"genericVariation":"The photos show this design and its general colors. Natural shape, shades and surface details vary, so your ring may not look exactly like the example shown.","violetVariation":"This batch is purple throughout, without yellow-gold patches. The shade, crystal arrangement and shape vary from ring to ring, so yours may look different from the example shown.","pinkVariation":"The photos show the pink-and-cream design. If you want a close match to the ring pictured, contact us to check the available piece before ordering.","unknownFit":"Fit and adjustment vary by design. Contact us to check this ring’s fit before ordering if you’re unsure. A size range shown for another ring may not apply.","knownFit":"This ring is adjustable and fits US sizes 8–12. Other designs may have a different fit.","care":"Stainless-steel ring setting; this refers to the metal setting, not the mineral. Store the ring somewhere dry and avoid knocking the mineral against hard surfaces.","unknownCare":"Contact us to confirm the setting material before ordering. Store the ring somewhere dry and avoid knocking the mineral against hard surfaces."};
      this.busy=false;
      this.addLabels=[];
      this.form=root.querySelector('.ee-edit__form');
      this.quantity=root.querySelector('[data-current-quantity]');
      this.error=root.querySelector('[data-error]');
      this.addButtons=[root.querySelector('[data-add-current]'),root.querySelector('[data-mobile-add]')].filter(Boolean);
      this.active=this.variants.find(variant=>variant.checked)||this.variants.find(variant=>!variant.disabled);
      this.previewIndex=Math.max(0,this.variants.indexOf(this.active));
      this.addLabels=this.addButtons.map(button=>button.dataset.availableLabel);
      const order=["EDIT-PINK-ENCOUNTER","EDIT-JWL-024","EDIT-JWL-007","EDIT-JWL-010","EDIT-JWL-011","EDIT-JWL-032","EDIT-JWL-031","EDIT-JWL-017","EDIT-JWL-009","EDIT-JWL-027","EDIT-JWL-023","EDIT-JWL-025","EDIT-JWL-026"];
      const grid=root.querySelector('[data-variant-grid]');
      [...grid.querySelectorAll('.ee-edit__variant-option')].sort((a,b)=>{const rank=option=>{const index=order.indexOf(option.querySelector('input').dataset.variantSku);return index<0?order.length:index};return rank(a)-rank(b)}).forEach(option=>grid.append(option));
      this.bind();this.filterGroup(this.group,false);this.observePurchase();this.render(false);
    }
    bind(){
      this.variants.forEach((variant,index)=>variant.addEventListener('change',()=>{if(!variant.checked)return;this.active=variant;this.previewIndex=index;this.galleryIndex=0;this.render(true)}));
      this.root.querySelector('[data-next-preview]').addEventListener('click',()=>this.selectNext());
      this.root.querySelector('[data-gallery-previous]')?.addEventListener('click',()=>this.stepGallery(-1));
      this.root.querySelector('[data-gallery-next]')?.addEventListener('click',()=>this.stepGallery(1));
      this.root.querySelectorAll('[data-quantity-action]').forEach(button=>button.addEventListener('click',()=>{const current=this.getQuantity();this.quantity.value=button.dataset.quantityAction==='plus'?Math.min(99,current+1):Math.max(1,current-1);this.renderTotals()}));
      this.quantity.addEventListener('change',()=>{this.quantity.value=this.getQuantity();this.renderTotals()});
      this.form.addEventListener('submit',event=>{event.preventDefault();this.addToCart()});
      this.root.querySelector('[data-mobile-add]').addEventListener('click',()=>this.form.requestSubmit());
      this.root.querySelectorAll('[data-select-variant-sku]').forEach(button=>button.addEventListener('click',()=>this.selectBySku(button.dataset.selectVariantSku)));
      this.root.querySelectorAll('[data-return-selection]').forEach(button=>button.addEventListener('click',()=>{const target=button.closest('.ee-edit__color-guide')?this.root.querySelector('.ee-edit__color-heading'):this.root.querySelector('.ee-edit__purchase');target.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth',block:'start'})}));
      this.root.querySelectorAll('[data-color-filter]').forEach(button=>button.addEventListener('click',()=>this.filterGroup(button.dataset.colorFilter,true)));
    }

    filterGroup(group,choose){
      this.group=group;
      const visible=this.variants.filter(variant=>group==='all'||variant.closest('.ee-edit__variant-option').dataset.color===group);
      this.root.querySelectorAll('.ee-edit__variant-option').forEach(option=>option.hidden=group!=='all'&&option.dataset.color!==group);
      this.root.querySelectorAll('[data-color-filter]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.colorFilter===group)));
      this.root.querySelector('[data-color-count]').textContent=visible.length+(visible.length===1?' style':' styles');
      if(choose&&visible.length&&!visible.includes(this.active)){this.active=visible.find(variant=>!variant.disabled)||visible[0];this.active.checked=true;this.galleryIndex=0;this.render(false)}
    }
    renderStory(){
      if(!this.active)return;
      const sku=this.active.dataset.variantSku,name=this.active.dataset.variantTitle;
      const copy=this.storyCopy[sku]||{title:'Take a\ncloser look.',body:'Like the color of '+name+'? Look at the shape and texture too. Use the available photos to see the stone and its setting before you choose.',view:Math.min(1,this.gallery().length-1),proof:[['Shape','Check the outline and how the stone sits above the band.'],['Color and texture','Look for the shades and surface details you like.'],['The setting','Look at the visible metal and how it holds the stone.']]};
      this.root.querySelector('[data-character-title]').textContent=copy.title;
      this.root.querySelector('[data-character-body]').textContent=copy.body;
      copy.proof.forEach(([heading,body],i)=>{this.root.querySelector('[data-proof-heading-'+(i+1)+']').textContent=heading;this.root.querySelector('[data-proof-body-'+(i+1)+']').textContent=body});
      const gallery=this.gallery(),view=gallery[Math.min(copy.view,gallery.length-1)];
      const image=this.root.querySelector('[data-difference-image]');
      if(image&&view){image.src=view.src;image.alt=name+' ring detail'}
      this.root.querySelector('[data-difference-caption]').textContent=name+' · your selection';
      this.root.querySelector('[data-facts-name]').textContent=name;
      this.root.querySelector('[data-selected-variation]').textContent=sku==='EDIT-JWL-024'?this.facts.violetVariation:sku==='EDIT-PINK-ENCOUNTER'?this.facts.pinkVariation:this.facts.genericVariation;
      this.root.querySelector('[data-selected-fit]').textContent=['EDIT-JWL-011','EDIT-JWL-032'].includes(sku)?this.facts.knownFit:this.facts.unknownFit;
      this.root.querySelector('[data-selected-care]').textContent=sku==='EDIT-PINK-ENCOUNTER'?this.facts.unknownCare:this.facts.care;
    }

    observePurchase(){
      const bar=this.root.querySelector('[data-mobile-bar]');const purchase=this.root.querySelector('.ee-edit__purchase');if(!bar||!purchase)return;
      if(!('IntersectionObserver' in window)){bar.classList.add('is-visible');return}
      this.purchaseObserver=new IntersectionObserver(entries=>{const entry=entries[0];const passedPurchase=!entry.isIntersecting&&entry.boundingClientRect.bottom<=0;bar.classList.toggle('is-visible',passedPurchase)},{threshold:0});this.purchaseObserver.observe(purchase);
    }
    selectNext(){
      const available=this.variants.filter(variant=>!variant.disabled&&(this.group==='all'||variant.closest('.ee-edit__variant-option').dataset.color===this.group));if(!available.length)return;
      const current=Math.max(0,available.indexOf(this.active));const next=available[(current+1)%available.length];next.checked=true;next.dispatchEvent(new Event('change',{bubbles:true}));
    }
    selectBySku(sku){
      const match=this.variants.find(variant=>variant.dataset.variantSku===sku&&!variant.disabled);if(!match)return;
      this.filterGroup(match.closest('.ee-edit__variant-option').dataset.color,false);match.checked=true;match.dispatchEvent(new Event('change',{bubbles:true}));
      this.root.querySelector('.ee-edit__purchase').scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth',block:'start'});
    }
    gallery(){
      if(!this.active)return [];
      const mapped=this.variantMedia[this.active.dataset.variantSku];
      return Array.isArray(mapped)&&mapped.length?mapped:[{src:this.active.dataset.variantImage,alt:this.active.dataset.variantTitle}];
    }
    setGalleryImage(index){
      const gallery=this.gallery();if(!gallery.length)return;
      this.galleryIndex=(index+gallery.length)%gallery.length;
      const item=gallery[this.galleryIndex];const image=this.root.querySelector('.ee-edit__hero-image');
      if(image){image.removeAttribute('srcset');image.removeAttribute('sizes');image.src=item.src;image.alt=item.alt||this.active.dataset.variantTitle}
      this.root.querySelector('[data-preview-caption]').textContent=`${this.active.dataset.variantTitle} · ${this.galleryIndex+1} of ${gallery.length}`;
      this.root.querySelectorAll('[data-gallery-index]').forEach(button=>button.setAttribute('aria-current',String(Number(button.dataset.galleryIndex)===this.galleryIndex)));
    }
    renderGallery(){
      const gallery=this.gallery();const thumbnails=this.root.querySelector('[data-gallery-thumbnails]');
      const previous=this.root.querySelector('[data-gallery-previous]');const next=this.root.querySelector('[data-gallery-next]');
      if(thumbnails){
        thumbnails.replaceChildren();
        gallery.forEach((item,index)=>{
          const button=document.createElement('button');button.type='button';button.className='ee-edit__gallery-thumbnail';button.dataset.galleryIndex=String(index);button.setAttribute('aria-label',`View ${this.active.dataset.variantTitle} image ${index+1} of ${gallery.length}`);button.setAttribute('aria-current',String(index===this.galleryIndex));
          const image=document.createElement('img');image.src=item.src;image.alt='';image.loading=index===0?'eager':'lazy';button.append(image);button.addEventListener('click',()=>this.setGalleryImage(index));thumbnails.append(button);
        });
      }
      [previous,next].forEach(button=>{if(button)button.hidden=gallery.length<2});
      this.setGalleryImage(this.galleryIndex);
    }
    stepGallery(step){const gallery=this.gallery();if(gallery.length>1)this.setGalleryImage(this.galleryIndex+step)}
    preview(shouldScroll){
      if(!this.active)return;this.renderGallery();const gallery=this.gallery();const main=gallery[0]||{src:this.active.dataset.variantImage};
      const differenceImage=this.root.querySelector('[data-difference-image]');
      if(differenceImage){differenceImage.removeAttribute('srcset');differenceImage.removeAttribute('sizes');differenceImage.src=main.src;differenceImage.alt=`${this.active.dataset.variantTitle} mineral ring enlarged to show its natural outline and surface`}
      const returnImage=this.root.querySelector('[data-return-image]');if(returnImage){returnImage.removeAttribute('srcset');returnImage.removeAttribute('sizes');returnImage.src=main.src}
      this.root.querySelector('[data-preview-name]').textContent=this.active.dataset.variantTitle;

      this.root.querySelector('[data-return-name]').textContent=this.active.dataset.variantTitle;
      if(shouldScroll&&window.matchMedia('(max-width: 760px)').matches)this.root.querySelector('.ee-edit__gallery').scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth',block:'start'});
    }
    money(cents){try{return new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:window.Shopify?.currency?.active||'USD'}).format(cents/100)}catch(e){return `$${(cents/100).toFixed(2)}`}}
    getQuantity(){return Math.min(99,Math.max(1,Number.parseInt(this.quantity.value,10)||1))}
    render(shouldScroll){
      if(!this.active)return;this.preview(shouldScroll);
      this.renderStory();
      this.root.querySelector('[data-current-variant-id]').value=this.active.dataset.variantId;
      this.root.querySelector('[data-current-name]').textContent=this.active.dataset.variantTitle;
      this.root.querySelector('[data-current-price]').textContent=this.money(Number(this.active.dataset.variantPrice));
      this.root.querySelector('[data-current-sku]').textContent=this.active.dataset.variantSku;
      this.root.querySelector('[data-mobile-name]').textContent=this.active.dataset.variantTitle;
      this.root.querySelector('[data-return-price]').textContent=this.money(Number(this.active.dataset.variantPrice));
      this.addButtons.forEach((button,i)=>{button.disabled=this.busy||this.active.disabled;button.textContent=this.active.disabled?this.root.dataset.soldOutLabel:this.addLabels[i]});this.error.hidden=true;this.renderTotals();
      const url=new URL(window.location.href);url.searchParams.set('variant',this.active.dataset.variantId);window.history.replaceState({},'',url);
    }
    renderTotals(){
      if(!this.active)return;this.quantity.value=this.getQuantity();this.root.querySelector('[data-mobile-total]').textContent=this.money(Number(this.active.dataset.variantPrice)*this.getQuantity());
    }
    async addToCart(){
      if(this.busy||!this.active||this.active.disabled)return;this.busy=true;const items=[{id:Number(this.active.dataset.variantId),quantity:this.getQuantity()}];
      this.addButtons.forEach(button=>{button.disabled=true;button.setAttribute('aria-busy','true')});this.error.hidden=true;
      try{
        const response=await fetch(`${window.Shopify?.routes?.root||'/'}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items,sections:['cart-drawer','cart-icon-bubble'],sections_url:window.location.pathname})});const data=await response.json();if(!response.ok)throw new Error(data.description||data.message||'Could not add this ring. Please try again.');
        const drawer=document.querySelector('cart-drawer');if(drawer&&typeof drawer.renderContents==='function')drawer.renderContents(data);else if(data.sections){Object.entries(data.sections).forEach(([id,html])=>{const current=document.getElementById(`shopify-section-${id}`);if(!current||!html)return;const next=new DOMParser().parseFromString(html,'text/html').getElementById(`shopify-section-${id}`);if(next)current.innerHTML=next.innerHTML})}
        document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true,detail:{source:'energyener-ring-edit'}}));document.dispatchEvent(new CustomEvent('cart-updated',{bubbles:true,detail:data}));if(drawer){drawer.classList.add('active');drawer.setAttribute('open','')}
      }catch(error){this.error.textContent=error.message;this.error.hidden=false}
      finally{this.busy=false;this.addButtons.forEach(button=>{button.disabled=this.active.disabled;button.removeAttribute('aria-busy')})}
    }
  }
  document.querySelectorAll('.ee-edit[data-section-id]').forEach(root=>new EnergyenerRingEdit(root));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
